
            import "data:text/css,.m-rightTopIcon-907ec0ca39%7Bposition:fixed;top:0;right:0;height:auto;margin-top:2em;margin-right:2em;width:200px%7D.m-smallIcon-907ec0ca39%7Bwidth:20px;height:20px;margin-bottom:-5px%7D";
            const result = {"rightTopIcon":"m-rightTopIcon-907ec0ca39","smallIcon":"m-smallIcon-907ec0ca39"};
            export default result;
          